export const NEW_CAMPAIGN = '/hyperx/campaigns/create';
export const CAMPAIGN_MANAGEMENT = '/hyperx/campaigns';
export const NEW_SEGMENT = '/hyperx/segments/create';
export const SEGMENT_LIST = '/hyperx/segments';
export const OFFER_LIST = '/hyperx/offers';
export const NEW_OFFER = '/hyperx/offers/create';
export const CAMPAIGN_DASHBOARD = '/hyperx/campaigns/view';
export const OFFER_DASHBOARD = '/hyperx/offers/view';
